document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".collection-modal-form").forEach((form) => {
    const container =
      form.closest("[data-featured-product]") ||
      form.closest('[id^="main-product-"]') ||
      form;

    const badgesEl =
      form.querySelector("[data-featured-variant-badges]") ||
      container.querySelector("[data-featured-variant-badges]") ||
      form.querySelector("[data-badges]") ||
      container.querySelector("[data-badges]");

    if (!badgesEl) return;

    let variants = [];
    let subscriptionBadgeMap = {};
    let oneTimeBadgeMap = {};

    const handle = form.dataset.productHandle;

    try {
      const parsedBadges = JSON.parse(badgesEl.textContent);

      /**
       * New format
       */
      subscriptionBadgeMap = parsedBadges.subscriptionBadges || {};
      oneTimeBadgeMap = parsedBadges.oneTimeBadges || {};

      /**
       * Fallback for old format, just in case another section
       * still uses "variantBadges".
       */
      if (!Object.keys(subscriptionBadgeMap).length && parsedBadges.variantBadges) {
        subscriptionBadgeMap = parsedBadges.variantBadges || {};
      }
    } catch (err) {
      console.error("Could not parse featured variant badges JSON", err);
      return;
    }

    if (!handle) return;

    fetch(`/products/${handle}.js`)
      .then((res) => res.json())
      .then((productData) => {
        variants = productData.variants || [];

        if (!variants.length) return;

        updateBadges();

        form.addEventListener("change", function (event) {
          if (
            event.target &&
            event.target.matches(
              ".product-option__radio, .variant-option, .rc-radio__input, #selling_plan"
            )
          ) {
            setTimeout(updateBadges, 0);
          }
        });

        /**
         * Extra listener on the container because the Recharge widget
         * may sit outside the form depending on your featured product markup.
         */
        if (container && container !== form) {
          container.addEventListener("change", function (event) {
            if (
              event.target &&
              event.target.matches(".rc-radio__input, #selling_plan")
            ) {
              setTimeout(updateBadges, 0);
            }
          });
        }
      })
      .catch((err) => {
        console.error("Could not fetch featured product JSON for badges", err);
      });

    function getSelectedPlanType() {
      /**
       * First check inside the form.
       */
      let checkedPlan = form.querySelector(".rc-radio__input:checked");

      /**
       * Fallback to the featured product container, because the custom
       * Recharge widget may not be inside .collection-modal-form.
       */
      if (!checkedPlan && container) {
        checkedPlan = container.querySelector(".rc-radio__input:checked");
      }

      if (checkedPlan && checkedPlan.value) {
        return checkedPlan.value;
      }

      /**
       * Your widget defaults to subscription.
       */
      return "subsave";
    }

    function getActiveBadgeMap() {
      const selectedPlanType = getSelectedPlanType();

      return selectedPlanType === "onetime"
        ? oneTimeBadgeMap
        : subscriptionBadgeMap;
    }

    function getOptionNamesInOrder() {
      const names = [];

      form.querySelectorAll(".product-option__radio, .variant-option").forEach((radio) => {
        if (!names.includes(radio.name)) {
          names.push(radio.name);
        }
      });

      return names;
    }

    function getSelectedOptions(optionNames) {
      return optionNames.map((name) => {
        const checked = form.querySelector(
          `.product-option__radio[name="${CSS.escape(name)}"]:checked, .variant-option[name="${CSS.escape(name)}"]:checked`
        );

        return checked ? checked.value : null;
      });
    }

    function updateBadges() {
      const allRadios = Array.from(
        form.querySelectorAll(".product-option__radio, .variant-option")
      );

      if (!allRadios.length) return;

      const badgeMap = getActiveBadgeMap();
      const optionNames = getOptionNamesInOrder();
      const selectedOptions = getSelectedOptions(optionNames);

      allRadios.forEach((radio) => {
        const label = form.querySelector(`label[for="${CSS.escape(radio.id)}"]`);

        if (!label) return;

        const badgeEl = label.querySelector(".variant-value");

        if (!badgeEl) return;

        const optionPosition = optionNames.indexOf(radio.name);

        if (optionPosition === -1) {
          badgeEl.textContent = "";
          badgeEl.style.display = "none";
          return;
        }

        const candidateOptions = selectedOptions.slice();
        candidateOptions[optionPosition] = radio.value;

        const matched = variants.find((variant) => {
          if (!Array.isArray(variant.options)) return false;
          if (variant.options.length !== candidateOptions.length) return false;

          return variant.options.every((opt, index) => {
            return opt === candidateOptions[index];
          });
        });

        const badgeText = matched ? badgeMap[String(matched.id)] || "" : "";

        badgeEl.textContent = badgeText;
        badgeEl.style.display = badgeText ? "" : "none";
      });
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".collection-modal-form").forEach((form) => {
    const container =
      form.closest("[data-featured-product]") ||
      form.closest('[id^="main-product-"]') ||
      form;

    const badgesEl =
      form.querySelector("[data-featured-variant-badges]") ||
      container.querySelector("[data-featured-variant-badges]");

    if (!badgesEl) return;

    let hiddenVariantMap = {};
    let variants = [];

    const handle = form.dataset.productHandle;

    try {
      const parsedBadges = JSON.parse(badgesEl.textContent);
      hiddenVariantMap = parsedBadges.hiddenVariants || {};
    } catch (err) {
      console.error("Could not parse featured hidden variants JSON", err);
      return;
    }

    if (!handle) return;

    fetch(`/products/${handle}.js`)
      .then((res) => res.json())
      .then((productData) => {
        variants = productData.variants || [];

        if (!variants.length) return;

        updateHiddenVariants();

        form.addEventListener("change", function (event) {
          if (
            event.target &&
            event.target.matches(".product-option__radio, .variant-option")
          ) {
            setTimeout(updateHiddenVariants, 0);
          }
        });
      })
      .catch((err) => {
        console.error("Could not fetch featured product JSON for hidden variants", err);
      });

    function isHiddenVariant(variantId) {
      const value = hiddenVariantMap[String(variantId)];

      return (
        value === true ||
        value === "true" ||
        value === 1 ||
        value === "1"
      );
    }

    function getOptionNamesInOrder() {
      const names = [];

      form.querySelectorAll(".product-option__radio, .variant-option").forEach((radio) => {
        if (!names.includes(radio.name)) {
          names.push(radio.name);
        }
      });

      return names;
    }

    function getSelectedOptions(optionNames) {
      return optionNames.map((name) => {
        const checked = form.querySelector(
          `.product-option__radio[name="${CSS.escape(name)}"]:checked, .variant-option[name="${CSS.escape(name)}"]:checked`
        );

        return checked ? checked.value : null;
      });
    }

    function getOptionWrapper(radio) {
      const label = form.querySelector(`label[for="${CSS.escape(radio.id)}"]`);

      return (
        radio.closest(".product-option__item") ||
        radio.closest(".variant-option__item") ||
        label?.closest(".product-option__item") ||
        label?.closest(".variant-option__item") ||
        label ||
        radio.parentElement
      );
    }

    function updateHiddenVariants() {
      const allRadios = Array.from(
        form.querySelectorAll(".product-option__radio, .variant-option")
      );

      if (!allRadios.length) return;

      const optionNames = getOptionNamesInOrder();
      const selectedOptions = getSelectedOptions(optionNames);

      allRadios.forEach((radio) => {
        const optionPosition = optionNames.indexOf(radio.name);

        if (optionPosition === -1) return;

        const candidateOptions = selectedOptions.slice();
        candidateOptions[optionPosition] = radio.value;

        const matched = variants.find((variant) => {
          if (!Array.isArray(variant.options)) return false;
          if (variant.options.length !== candidateOptions.length) return false;

          return variant.options.every((opt, index) => {
            return opt === candidateOptions[index];
          });
        });

        const hidden = matched ? isHiddenVariant(matched.id) : false;
        const wrapper = getOptionWrapper(radio);

        if (wrapper) {
          wrapper.style.display = hidden ? "none" : "";
        }

        radio.disabled = hidden;

        /**
         * If the currently selected option becomes hidden,
         * move selection to the first visible option in the same option group.
         */
        if (hidden && radio.checked) {
          const replacement = allRadios.find((candidate) => {
            if (candidate.name !== radio.name) return false;
            if (candidate === radio) return false;

            const candidateWrapper = getOptionWrapper(candidate);

            return (
              !candidate.disabled &&
              candidateWrapper &&
              candidateWrapper.style.display !== "none"
            );
          });

          if (replacement) {
            replacement.checked = true;
            replacement.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }
      });
    }
  });
});